<template>
  <base-settings-page
    :title="$t('hitl.settings.agent-status.title')"
    :show-sidebar="showSidebar"
    :show-add-button="!isInitializing"
    :is-initializing="isInitializing"
    @add-button-click="$emit('open-create-sidebar')"
  >
    <template #content>
      <agent-status-item-list
        :status-options="statusOptions"
        :default-status-key="defaultStatusKey"
        :target-key="targetKey"
        :is-disabled="isUpdating"
        @items-order-change="$emit('items-order-change', $event)"
        @item-click="$emit('open-update-sidebar', $event)"
        @default-key-change="$emit('default-key-change', $event)"
      />
    </template>

    <template #sidebar>
      <agent-status-item-sidebar-container />
    </template>
  </base-settings-page>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';

import AgentStatusItemList from './AgentStatusItemList.vue';
import AgentStatusItemSidebarContainer from '../containers/AgentStatusItemSidebarContainer.vue';
import { BaseSettingsPage } from '@/modules/common-settings-ui';
import { AgentStatus } from '@/types';

export default defineComponent({
  name: 'AgentStatusSettings',
  components: {
    BaseSettingsPage,
    AgentStatusItemList,
    AgentStatusItemSidebarContainer,
  },
  props: {
    statusOptions: {
      type: Array as PropType<AgentStatus[]>,
      default: () => [],
    },
    defaultStatusKey: {
      type: String,
      default: '',
    },
    targetKey: {
      type: String,
      default: '',
    },
    showSidebar: Boolean,
    isInitializing: Boolean,
    isUpdating: Boolean,
  },
  emits: [
    'items-order-change',
    'open-create-sidebar',
    'open-update-sidebar',
    'default-key-change',
  ],
});
</script>
